<section class="container">
<div
  class="row component-card align-items-center justify-content-center mt-4 py-5"
>
  <div class="col-12 mb-4">
    <h3 class="title text-center mb-5">
      <span class="strok-text">{{ data.details.title.split(" ")[0] }}</span>
      {{ data.details.title.split(" ").slice(1).join(" ") }}
    </h3>
  </div>

  <div class="col-12 col-lg-6 mb-5" *ngFor="let item of data.details.services">
    <div
      class="service-row row g-3 align-items-center px-3 py-3 rounded-4 shadow-sm bg-white h-100 mx-0"
      [routerLink]="data.details.isDetails ? getDetailsUrl(item) : null"
      [ngClass]="{ pointer: data.details.isDetails }"
    >
      <div class="col-12 col-md-4 text-center">
        <img
          class="service-img"
          [src]="item.imageIconPath"
          [alt]="item.imageAlt"
        />
      </div>

      <div class="col-12 col-md-8">
        <h4 class="service-title mb-2">{{ item.titleTr }}</h4>
        <p class="service-summary" [innerHTML]="item.summary"></p>
      </div>
    </div>
  </div>
</div>
</section>